import r from"./_castPath.js";import t from"./_toKey.js";var o=r,a=t;var e=function(r,t){for(var e=0,f=(t=o(t,r)).length;null!=r&&e<f;)r=r[a(t[e++])];return e&&e==f?r:void 0};export{e as default};
//# sourceMappingURL=_baseGet.js.map
